import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46214984"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))

import { Ref, ref, onMounted } from "vue";
import get from "lodash-es/get";
import includes from "lodash-es/includes";

import { useGlobalStore } from "@/store/pinia/global";

// DEFIEN STORE

export default /*#__PURE__*/_defineComponent({
  props: {
    view: {
        required: false,
        type: Boolean,
    },
},
  emits: ["getData"],
  setup(__props, { emit }) {

const props = __props

/**
 * @author Tornike Jortmenadze (Jortsoft)
 */

// IMPORTS
const store = useGlobalStore();

// DEFINE EMITS


// DEFINE PROPS


// DEFINE GLOBAL VARIABLES
const activeClass: Ref<number> = ref(1);
const iconArr: Ref<string[]> = ref(
    get(props, "view") ? ["3D", "2D"] : ["$", "₾"]
);

// CUSTOM FUNCTIONS
const switchButton = (): void => {
    if (activeClass.value >= 1) activeClass.value = -1;
    activeClass.value++;
    if (includes(iconArr.value, "₾"))
        store.currency = iconArr.value[activeClass.value];
    emit("getData", iconArr.value[activeClass.value]);
};

// FUNCTION EXPRESSION
onMounted(() => {
    if (includes(iconArr.value, "₾") && store.currency === "$") {
        switchButton();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["switcher", { view: __props.view }])
  }, [
    _createElementVNode("button", {
      class: _normalizeClass({ active: activeClass.value === 1 }),
      onClick: switchButton
    }, [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iconArr.value, (item, index) => {
        return (_openBlock(), _createElementBlock("p", {
          class: _normalizeClass(["wc-lg anek latin semi-bold", { active: activeClass.value === index }]),
          key: index
        }, _toDisplayString(item), 3))
      }), 128))
    ], 2)
  ], 2))
}
}

})